<template>
  <div class="container-fluid">
    <b-card class="mb-1">
      <div class="d-flex align-items-end flex-wrap">
        <div class="mr-1">
          <label class="mb-0">From</label>
          <b-form-input v-model="from" type="date" class="w-auto" />
        </div>
        <div class="mr-1">
          <label class="mb-0">To</label>
          <b-form-input v-model="to" type="date" class="w-auto" />
        </div>
        <b-button variant="primary" class="ml-1 mt-1" @click="loadSummary">Load</b-button>
      </div>
    </b-card>

    <b-row>
      <b-col md="3"><b-card><div class="h5">Total Sent</div><div class="display-4">{{ summary.total_sent || 0 }}</div></b-card></b-col>
      <b-col md="3"><b-card><div class="h5">Clicked</div><div class="display-4">{{ summary.clicked || 0 }}</div></b-card></b-col>
      <b-col md="3"><b-card><div class="h5">Paid</div><div class="display-4">{{ summary.paid || 0 }}</div></b-card></b-col>
      <b-col md="3"><b-card><div class="h5">CTR / Conv</div><div class="display-4">{{ (summary.ctr || 0) + '% / ' + (summary.conversion || 0) + '%' }}</div></b-card></b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col md="7">
        <b-card>
          <div class="h5 mb-1">By Stage</div>
          <apexchart type="bar" height="300" :options="stageOptions" :series="stageSeries" />
        </b-card>
      </b-col>
      <b-col md="5">
        <b-card>
          <div class="h5 mb-1">By Language</div>
          <apexchart type="donut" height="300" :options="langOptions" :series="langSeries" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'IspNotificationSummary',
  components: { apexchart: VueApexCharts },
  data() {
    const today = moment().format('YYYY-MM-DD')
    const from = moment().subtract(30, 'days').format('YYYY-MM-DD')
    return {
      from,
      to: today,
      summary: {},
      // charts
      stageOptions: {
        chart: { toolbar: { show: false } },
        xaxis: { categories: [] },
        dataLabels: { enabled: false },
        colors: ['#7367F0'],
      },
      stageSeries: [{ name: 'Sent', data: [] }],
      langOptions: {
        labels: [],
        legend: { position: 'bottom' },
        colors: ['#28C76F', '#EA5455', '#00CFE8', '#FF9F43'],
      },
      langSeries: [],
    }
  },
  methods: {
    async loadSummary() {
      try {
        const { jwt } = useJwt(this.$http, {})
        const { data } = await jwt.metricsNotificationSummary({ from: this.from, to: this.to })
        if (data && data.data) {
          this.summary = data.data
          this.buildCharts()
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },
    buildCharts() {
      const stages = (this.summary.by_stage || []).map(x => ({ stage: x.stage || '-', count: x.c }))
      this.stageOptions = {
        ...this.stageOptions,
        xaxis: { categories: stages.map(s => s.stage) },
      }
      this.stageSeries = [{ name: 'Sent', data: stages.map(s => Number(s.count || s.c || 0)) }]

      const langs = (this.summary.by_language || []).map(x => ({ language: x.language || '-', count: x.c }))
      this.langOptions = { ...this.langOptions, labels: langs.map(l => l.language) }
      this.langSeries = langs.map(l => Number(l.count || l.c || 0))
    },
  },
  mounted() {
    this.loadSummary()
  },
}
</script>

<style scoped>
</style>
